import {Routes, RouterModule, PreloadAllModules} from '@angular/router';
import {ModuleWithProviders} from '@angular/core';

import {NotFoundComponent} from './pages/errors/not-found/not-found.component';

export const routes: Routes = [
    {path: '', redirectTo: 'pages', pathMatch: 'full'},
    {path: 'pages', loadChildren: 'app/pages/pages.module#PagesModule'},
    {path: 'privacy-policy', loadChildren: 'app/pages/privacy-policy/privacy-policy.module#PrivacyPolicyModule'},
    {path: 'login', loadChildren: 'app/pages/login/login.module#LoginModule'},
    {path: 'register', loadChildren: 'app/pages/register/register.module#RegisterModule'},
    {path: '**', component: NotFoundComponent},
];

export const routing: ModuleWithProviders = RouterModule.forRoot(routes, {
    preloadingStrategy: PreloadAllModules,
    onSameUrlNavigation: 'reload',
    // useHash: true
});



// WEBPACK FOOTER //
// ./src/app/app.routing.ts